module.exports = __webpack_public_path__ + "static/media/stargazer.1a235b8d.png";